module.exports = __webpack_public_path__ + "img/bg3.85cf83a9.png";